import { render, staticRenderFns } from "./banned_users.vue?vue&type=template&id=ef857232"
import script from "./banned_users.vue?vue&type=script&lang=js"
export * from "./banned_users.vue?vue&type=script&lang=js"
import style0 from "./banned_users.vue?vue&type=style&index=0&id=ef857232&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports